import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { PeriodTypeView } from '@/types'

type PersonnelStore = {
  view: PeriodTypeView
  setView: (view: PeriodTypeView) => void
}

export const usePersonnelStore = create<PersonnelStore>()(
  devtools(
    persist(
      set => ({
        view: `monthly`,
        setView: (view: PeriodTypeView) => set({ view })
      }),
      {
        name: `personnel_store`,
        storage: createJSONStorage(() => sessionStorage)
      }
    )
  )
)
